<template>
  <modal
    v-show="isOpen"
    :modal="isOpen"
    class="qr-code-modal"
    @close="closeModal"
  >
    <template slot="body">
      <h4 class="modal-content-title">
        {{ title }}
      </h4>
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="qr-code-modal__intro"
        v-html="introHtml"
      />
      <!-- eslint-enable vue/no-v-html -->
      <canvas
        ref="qrCanvas"
        class="qr-code-modal__canvas"
      />
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/modal/Modal.vue';
import QRCode from 'qrcode';

export default {
  name: 'QrCodeModal',
  components: {
    Modal,
  },
  props: {
    title: {
      type: String,
      default: () => '',
    },
    introHtml: {
      type: String,
      default: () => '',
    },
    qrCodeValue: {
      type: String,
      default: () => '',
    },
    isOpen: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    qrCodeValue(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.renderQrCode(newValue);
      }
    },
  },
  mounted() {
    this.renderQrCode();
  },
  methods: {
    renderQrCode() {
      if (this.qrCodeValue) {
        QRCode.toCanvas(this.$refs.qrCanvas, this.qrCodeValue, (error) => {
          if (error) console.error(error);
        });
      } else {
        const canvas = this.$refs.qrCanvas;
        const context = canvas.getContext('2d');
        context.clearRect(0, 0, canvas.width, canvas.height);
      }
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="postcss">
.qr-code-modal {
  &__intro {
    @apply text-center;
  }

  &__qr-image {
    @apply w-full mx-auto;
    max-width: 320px;
  }

  &__canvas {
    @apply mx-auto;
  }

  .modal {
    @apply px-0 py-8 rounded-md;

    @screen md {
    }

    &-body {
      @apply px-12;
    }

    &-header {
      @apply static border-0;
    }

    &-content-title {
      @apply text-secondary-alpha text-center mb-4;
    }
  }
}
</style>
